var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7349 25.0319V27.9999H17.8587L25.4766 20.7619L22.3528 17.7939L14.7349 25.0319Z",
    fill: "#5D5DED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5758 8.4L14.7349 0H2.94698C1.32614 0 0.0147352 1.26 0.0147352 2.8L0 25.2C0 26.74 1.31141 28 2.93225 28H11.7879V23.87L23.5758 12.67V8.4ZM13.2614 9.8V2.1L21.3656 9.8H13.2614Z",
    fill: "#5D5DED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5689 16.8L26.5227 15.806C25.9481 15.26 25.0198 15.26 24.4451 15.806L23.3989 16.8L26.5227 19.768L27.5689 18.774C28.1436 18.228 28.1436 17.346 27.5689 16.8Z",
    fill: "#5D5DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.63541ce64c574cd6e62b5f331acb7bca.svg";
export { ForwardRef as ReactComponent };